export const DEFAULT_AUTHENTICATED_REDIRECT = '/';
export const DEFAULT_UNAUTHENTICATED_REDIRECT = '/login';

// Valide une URL de retour fournie côté client : seuls les chemins internes
// relatifs sont autorisés, afin d'éviter toute redirection ouverte.
export function safeRedirect(
  value: string | null | undefined,
  fallback: string = DEFAULT_AUTHENTICATED_REDIRECT,
): string {
  if (!value || typeof value !== 'string') return fallback;
  if (!value.startsWith('/')) return fallback;
  if (value.startsWith('//') || value.startsWith('/\\')) return fallback;
  if (value.includes('://')) return fallback;
  return value;
}
